import { Base } from "./bannerSlider.base";
import { ProgressBar } from "./components/progressBar/progressBar";
import { Slider } from "./components/slider";
import { ImageSlide } from "./components/slides/image";

export const BannerSlider = Object.assign(Base, {
    Slider: Slider,
    Content: ImageSlide,
    ProgressBar: ProgressBar
});
